<template>
  <div
    id="map"
    class="maps"
    ref="map"
    :class="{'sailing-map-marker-rider-entrega': orderData.status >= 1400}"
  >
    <sailing-map-view
      :scaleControl="true"
      :zoomControl="false"
      :zoom="zoom"
      @ready="ready"
      :center="position"
      mapMode="standard"
      noBabelPillFile="true"
    >
      <!-- 骑手 -->
      <sailing-map-marker
        v-if="rider"
        :infoWindow="riderInfoString"
        :infoWindowOptions="infoWindowOptions"
        :icon="riderIcon"
        :position="rider"
      ></sailing-map-marker>
      <!--  顾客 C1 -->
      <sailing-map-marker
        v-if="customerOne"
        :infoWindow="customerOneInfoString"
        :icon="customerOneIcon"
        :position="customerOne"
        :infoWindowOptions="infoWindowOptions"
      ></sailing-map-marker>
      <!--  顾客 C2 -->
      <sailing-map-marker
        v-if="customerTwo"
        :infoWindow="customerOneInfoString"
        :icon="customerTwoIcon"
        :position="customerTwo"
      ></sailing-map-marker>
      <sailing-map-polyline
        v-if="polylinePath"
        :showDir="true"
        :path="polylinePath"
        :strokeWeight="4"
        :strokeOpacity="0.15"
        strokeColor="#272C2D"
      ></sailing-map-polyline>
    </sailing-map-view>
    <div
      @click="reset"
      v-if="mapReadyComplete"
      class="reset-map flex finger-style"
    >
      <i class="icon-outlined_refresh"></i>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { angle, angleName } from '@/utils/mapAngle';
import { SailingMapView, SailingMapMarker, SailingMapPolyline, MapAlgo } from '@didi/sailing-map';
import {debounce} from 'lodash-es';
import entrega_c1 from '@/assets/images/didi/map/entrega-c1.png'
import entrega_c2 from '@/assets/images/didi/map/entrega-c2.png'
import entrega_c2_99 from '@/assets/images/didi/map/entrega-c2-99.png'

// C1 一般来说是寄件人 ，当然也可能不是；C2 一般为收件人
export default {
  name: 'Map',
  components: {
    SailingMapView,
    SailingMapMarker,
    SailingMapPolyline,
  },
  props: {
    mapData: Object,
    orderData: {
      type:Object,
      default:() =>{}
    },
    orderStatus:Number,
    isH5: Boolean,
    serverApiTime: Number,
  },
  data() {
    return {
      // 地图
      mapReadyComplete: false,
      zoom: null,
      map: null,
      distance: 140,
      infoWindowOptions: {
        // 当前点是否在视口内
        disableAutoPan: true,
        multiple: true
      },
      position: null,
      countdownEl: '00:00',
      recordTime: 0,
      waitTime: 30000,
      riderInfoString: false, // 骑手气泡
      customerOneInfoString: false, // C1气泡
      timer: null,
      bubbleCardEl: null,
      mapAlgo: null,
    };
  },
  computed: {
    ...mapState({
      country: ({ common }) => common.country,
    }),
    is99() {
      return this.country === 'BR'
    },
    // 骑手
    rider() {
      if (this.mapData?.riderLat && this.mapData?.riderLng) {
        return {
          lat: this.mapData?.riderLat,
          lng: this.mapData?.riderLng,
        };
      } else {
        return false;
      }
    },
    // 用户
    customerOne() {
      if (this.orderData?.status < 1400 && this.mapData?.senderLat && this.mapData?.senderLng) {
        return {
          lat: this.mapData?.senderLat,
          lng: this.mapData?.senderLng,
        };
      } else {
        return false;
      }
    },
    customerTwo() {
      if (this.orderData?.status >= 1400 && this.mapData?.receiverLat && this.mapData?.receiverLng) {
        return {
          lat: this.mapData?.receiverLat,
          lng: this.mapData?.receiverLng,
        };
      } else {
        return false;
      }
    },
    // 路线
    polylinePath() {
      let path = []
      let status = this.orderData?.status
      if (status >= 1200 && status < 1400) {
        path.push({
          lat: this.mapData?.riderLat,
          lng: this.mapData?.riderLng,
        }, {
          lat: this.mapData?.senderLat,
          lng: this.mapData?.senderLng,
        })
      } else if(status >= 1400) {
        path.push({
          lat: this.mapData?.riderLat,
          lng: this.mapData?.riderLng,
        }, {
          lat: this.mapData?.receiverLat,
          lng: this.mapData?.receiverLng,
        })
      }
      return path.length ? path : false
    },
    // icon
    customerOneIcon() {
      const status = this.orderData?.status;
      let y = status === 1100 ? 50 : 14
      return {
        url: entrega_c1,
        scaledSize: {
          width: 28,
          height: 28,
        },
        anchor: {
          x: 14,
          y: y
        }
      }
    },
    customerTwoIcon() {
      let url = this.is99 ? entrega_c2_99 : entrega_c2
      return {
      url: url,
      scaledSize: {
        width: 28,
        height: 28,
      },
      anchor: {
        x: 14,
        y: 14
      }
    }
    },
    riderIcon() {
      let result = null;
      const status = this.orderData?.status;
      if (status === 1200) {
        // 200 骑手去商家
        result = angle(this.rider, this.customerOne);
      } else if (status === 1400 || status === 1500) {
        // 400骑手去用户 500已到达用户附近
        result = angle(this.rider, this.customerTwo);
      }
      // 该注释不要删除：这是为了能够然让我们搜索到这个路径，从而标识这个资源有被使用；@/assets/images/99/map/east_north_east.png @/assets/images/didi/map/east_north_east.png
      let url = result ? require(`@/assets/images/${this.is99 ? '99' : 'didi'}/map/${result.toLowerCase()}.png`) : ''
      return {
        url,
        scaledSize: {
          width: 60,
          height: 60,
        },
        anchor: {
          x: 30,
          y: 45
        }
      };
    },
    apiCountDown() {
      const { countDown = 0 } = this.mapData?.tip || 0;
      // 有倒计时
      return countDown - this.serverApiTime;
    },
  },
  watch: {
    apiCountDown: {
      handler: function(newV, oldV) {
        this.clearIntervalFn();
        this.setMapInit();
        if (newV > 0) {
          this.TimeDown(newV);
        }
        this.riderInfoString = this.infoString('rider');
        this.customerOneInfoString = this.infoString('customerOne');
        this.listenEl();
      },
      immediate: true,
    },
  },
  mounted() {
    this.$once('hook:beforeDestroy', () => {
      this.clearIntervalFn();
    });
    this.$nextTick(() => {
      try {
        this.mapAlgo = new MapAlgo(this.$refs?.map);
      } catch{}
        this.setMapInit();
    })
  },
  methods: {
    setMapInit() {
      const mapPointArr = [];
      if (this.rider) mapPointArr.push(this.rider);
      if (this.customerTwo) mapPointArr.push(this.customerTwo);
      if (this.customerOne) mapPointArr.push(this.customerOne);
      if (mapPointArr.length === 1) {
        mapPointArr.push(mapPointArr[0])
      }
      try {
        this.mapInit(mapPointArr);
      } catch {}
    },
    mapInit(mapPointArr) {
      const data = this.mapAlgo.getBestView(mapPointArr);
      this.position = data.center;
      this.zoom = data.zoom-1;
      this.map.reset({
        zoom: this.zoom,
        center: this.position,
      });
    },
    ready(map) {
      this.listenEl();
      this.map = map;
      this.mapReadyComplete = true;
    },
    reset: function() {
      // 30秒 提示
      const nowTime = +new Date();
      if (nowTime - this.recordTime > this.waitTime) {
        // 如果当前点击时间减去之前记录的时间小于等待时间 执行，否则提示消息
        this.recordTime = +new Date(); // 点击的时候记录当前时间
        this.$emit('initData');
        this.setMapInit()
      } else {
        this.mapTipFn();
      }
    },
    // 30秒复位
    mapTipFn: debounce(function() {
      this.$utils.warningToast(this.$t('操作太快啦，请稍后尝试'))
    }, 300),

    // 卡片气泡的逻辑
    async listenEl() {
      this.bubbleCardEl = await this.getRealDom('gm-style-iw-c');
    },
    getRealDom(domName) {
      return new Promise((resolve, reject) => {
        let count = 0;
        let flag = null;
        flag = setInterval(() => {
          let dom = document.getElementsByClassName(domName)?.[0];
          if (dom) {
            clearInterval(flag);
            flag = null;
            resolve(dom);
          }
          if (count > 60) {
            clearInterval(flag);
            flag = null;
          }
          count++;
        }, 100);
      });
    },
    getElDom() {
      const { countDown, statusDesc = '', subStatusDesc = '' } = this.mapData?.tip;
      return this.h5AirCardEl(countDown, statusDesc, subStatusDesc);
    },
    TimeDown(endDateStr) {
      let totalSeconds = endDateStr;
      this.timer = setInterval(() => {
        let dom = document.querySelector('#countdown-el-id-only')
        this.listenEl();
        this.computationTime(totalSeconds);
        dom && (dom.textContent = this.countdownEl)
        // this.riderInfoString = this.infoString('rider');
        // this.customerOneInfoString = this.infoString('customerOne');
        totalSeconds--;
        if (totalSeconds <= 0) {
          // 如果时间为0清楚倒计时
          this.$emit('initData');
          this.clearIntervalFn();
        }
      }, 1000);
    },
    computationTime(timeDifference) {
      if (timeDifference < 0) {
        // 如果有倒计时小于了0，则给默认
        this.countdownEl = `00:00`;
        return;
      }
      // 取模（余数）
      let modulo = timeDifference % (60 * 60 * 24);
      //小时数
      modulo = modulo % (60 * 60);
      //分钟
      let minutes = Math.floor(modulo / 60);
      minutes < 10 ? (minutes = `0${minutes}`) : minutes;
      //秒
      let seconds = modulo % 60;
      seconds < 10 ? (seconds = `0${seconds}`) : seconds;
      this.countdownEl = `${minutes}:${seconds}`;
    },
    infoString(type) {
      const { status } = this.orderData;
      if (status == 1100 || status == 1200) {
        if (type === 'customerOne') {
          return this.getElDom();
        } else {
          return false;
        }
      } else if (status == 1300 || status == 1400 || status == 1500) {
        if (type === 'rider') {
          return this.getElDom();
        } else {
          return false;
        }
      } else {
        // 重复执行
        return false;
      }
    },
    //h5的卡片样式
    h5AirCardEl(countDown, statusDesc, subStatusDesc) {
      // 移动端div
      if (countDown) {
        return this.h5CountDown(statusDesc, subStatusDesc);
      }
      return `
        <div class="map-tip_content_h5" id="sailingMap-info-window">
          <div class="finger-style map-tips_h5_title ellipsis">
            <div class="js-click ellipsis">${statusDesc}</div>
          </div>
          <div class="map-tips_h5_desc">${subStatusDesc}</div>
        </div>
        `;
    },
    // 倒计时
    h5CountDown(statusDesc, subStatusDesc) {
      return `
        <div class="map-tip_content_h5" id="sailingMap-info-window">
          <div class="finger-style map-tips_h5_title ellipsis">
            <div class="js-click ellipsis">${statusDesc}</div>
          </div>
          <div class="map-tips_h5_desc">${subStatusDesc}</div>
        </div>
        <div class="map_count_down_box">
          <span id="countdown-el-id-only">${this.countdownEl}</span>
          <span class="map_count_down_box_shadow"></span>
        </div>
      `;
    },
    clearIntervalFn() {
      clearInterval(this.timer);
    },
  },
  beforeDestroy() {
    this.clearIntervalFn();
  },
};
</script>
<style lang="scss">
.gm-style-iw-c {
  padding: 12px !important;
  border: none !important;
  outline: none;
  background: #1bb17c !important;
  border-radius: 4px !important;
  overflow: unset !important;
  div {
    border: none !important;
  }
}
.gm-style-iw-t::after {
  background: green !important;
}
.sailing-map-marker-rider-entrega {
  .gm-style-iw-c,
  .gm-style-iw-t::after,
  .map-tip_content_h5 {
    @include themeBackgroundColorImportant();
  }
}
.gm-style-iw-d {
  overflow: unset !important;
}
.infowindow {
  color: #fff;
}
.reset-map {
  position: absolute;
  right: 40px;
  bottom: 40px;
  width: 40px;
  height: 40px;
  background: #ffffff;
  box-shadow: 0px 8px 40px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  i {
    font-size: 25px;
  }
}
.maps {
  position: relative;
  height: 100%;
  outline: none;
  .map-view {
    > div {
      > div {
        > div {
          border: none !important;
          outline: none;
        }
      }
    }
  }
}

.gm-style-iw-t::after {
  background: #1bb17c !important;
  border-radius: 0 0 0 4px;
}


.map-tips_h5 {
  display: flex;
  align-items: center;
}
.gm-ui-hover-effect {
  display: none !important;
}

.map_count_down_box {
  position: absolute;
  bottom: -75px;
  left: 50%;
  margin-left: -30px;
  padding: 18px 0 0;
  width: 61px;
  height: 61px;
  text-align: center;
  line-height: 20px;
  font-size: 16px;
  font-family: 'Aspira Medium';
  font-weight: 500;
  color: #ffffff;
  border-radius: 50%;
  // background: #272C2D;
  background: url('~@/assets/images/didi/map/entrega-bubble.png') no-repeat center center;
  background-size: 100%;
}
.map_count_down_box_shadow {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: -1;
  margin-left: -117px;
  margin-top: -114px;
  width: 234px;
  height: 234px;
  &::after {
    content: ' ';
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: -1;
    margin-left: -117px;
    margin-top: -114px;
    width: 234px;
    height: 234px;
    opacity: 0.5;
    border-radius: 50%;
    transform: scale(0.1, 0.1);
    background-image: radial-gradient(#FFFFFF 0%, #EDF7FF 50%, #6ABDFA 100%);
    animation: scaleRound 2s ease-in-out infinite;
  }
  &::before {
    content: ' ';
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: -1;
    margin-left: -117px;
    margin-top: -114px;
    width: 234px;
    height: 234px;
    opacity: 0.5;
    border-radius: 50%;
    transform: scale(0.1, 0.1);
    background-image: radial-gradient(#FFFFFF 0%, #EDF7FF 50%, #6ABDFA 100%);
    animation: scaleRound 2s .8s ease-in-out infinite;
  }
}
@keyframes scaleRound {
  0% {
    opacity: 0.5;
    transform: scale(0.1, 0.1);
    background-image: radial-gradient(#FFFFFF 0%, #EDF7FF 50%, #6ABDFA 100%);
  }
  100% {
    opacity: 0;
    transform: scale(2.5, 2.5);
    background-image: radial-gradient(#FFFFFF 0%, #EDF7FF 50%, #6ABDFA 100%);
  }
}
// h5样式
@media screen and (max-width: 768px) {
  .map-tip_content_h5 {
    position: relative;
    padding: rem(24) rem(18);
    border-radius: 4px !important;
    background: #1bb17c !important;
    z-index: 1;
  }
  .reset-map {
    position: absolute;
    right: rem(50);
    bottom: rem(50);
    width: rem(50);
    height: rem(50);
    background: #ffffff;
    box-shadow: 0px rem(8) rem(40) 0px rgba(0, 0, 0, 0.12);
    border-radius: rem(4);
    i {
      font-size: rem(25);
    }
  }
  .map-tips_h5_title {
    line-height: 1;
    font-family: 'Aspira Medium';
    font-size: rem(32);
    color: #ffffff;
    font-weight: 500;
    display: flex;
    align-items: center;
    .js-click{
     max-width: rem(500);
    }
    .icon-outline_entrance{
      font-size: rem(18);
      margin-left: rem(4);
    }
  }
  .map-tips_h5_desc {
    font-family: 'Aspira Light';
    font-size: rem(24);
    color: #ffffff;
    font-weight: 200;
    display: flex;
    align-items: center;
  }
  .h5-time_desc {
    font-family: 'Aspira Medium';
    font-size: rem(24);
    color: #ffffff;
    font-weight: 500;
  }
  .gm-style-iw-c {
    padding: 0 !important;
    border-radius: rem(12) !important;
    box-shadow: rem(20) rem(16) rem(80) rgba(0, 0, 0, 12%) !important;
    max-width: rem(420) !important;
  } 
  .gm-style-iw-t::after {
    border-radius: 0 0 0 rem(8);
  }
}
</style>
